module.exports = __webpack_public_path__ + "img/PD1505106775140073472.b746436b.png";